import {makeStyles} from '@material-ui/core/styles';

export const usePackagesStyles = makeStyles((theme) => ({
    paper: {
        backgroundColor: '#f9fafb',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2, 0),
        minHeight: '100vh'
    },
    paperHeader: {
        display: 'flex',
        width: '100%',
        padding: '10px 40px',
        marginTop: '30px'
    },
    headerText: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'start',
        marginLeft: '10%',
        width: '50%',
        '& h3': {
            fontSize: '30px',
            textAlign: 'center',
            width: '100%',
            fontWeight: 'bold',
            marginBottom: '10px'
        },
        '& h4': {
            fontSize: '20px',
            textAlign: 'center',
            width: '100%'
        }
    },
    companyLogo: {
        marginTop: theme.spacing(1),
        '& img': {
            width: 'fit-content',
            height: '64%',
            objectFit: 'contain'
        }
    },
    cardContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    gridContainer: {
        display: 'flex',
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: theme.spacing(2, 0),
        '&::-webkit-scrollbar': {
            height: '8px',
            width: '6px'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#555',
        },
    },
    gridItem: {
        position: 'relative',
        flex: '0 0 auto',
    },
    card: {
        width: 300,
        margin: theme.spacing(2),
        borderRadius: 12,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e0e0e0',
        transition: 'transform 0.3s',
        '&.currentPlan': {
            transition: 'none',
            transform: 'scale(1.05)',
            border: '1px solid #4659fd'
        },
        '&:hover': {
            transform: 'scale(1.05)',
        },
        '& .MuiCardContent-root': {
            padding: 0
        },
        minHeight: '400px',
        maxHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: theme.spacing(2),
        position: 'relative'
    },
    price: {
        fontSize: '2.5rem',
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    validity: {
        color: '#f50057',
        fontSize: '0.9rem',
    },
    description: {
        color: '#757575',
        marginBottom: theme.spacing(2),
    },
    feature: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
        '&::before': {
            content: '"✔"',
            color: '#1976d2',
            marginRight: theme.spacing(1),
        },
    },
    button: {
        marginTop: theme.spacing(2),
        textTransform: 'none',
        padding: theme.spacing(1, 3),
        borderRadius: 7,
        fontSize: '16px',
        fontWeight: 'bold',
        backgroundColor: '#4659fd !important',
        '&:hover': {
            backgroundColor: '#2a3cdb !important'
        }
    },
    toggleContainer: (props) => ({
        display: 'flex',
        backgroundColor: '#e0e0e0',
        borderRadius: 14,
        width: props.hasCustom ? 285 : 200,
        padding: 4,
        cursor: 'pointer',
        position: 'relative',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2),
    }),
    toggleOption: {
        flex: 1,
        textAlign: 'center',
        padding: '8px 0',
        color: '#333',
        fontSize: 14,
        fontWeight: 500,
        transition: 'color 0.3s ease',
        zIndex: 1,
        '&.active': {
            color: '#000',
        },
        userSelect: 'none'
    },
    toggleSlider: (props) => ({
        content: '""',
        position: 'absolute',
        top: 4,
        bottom: 4,
        width: props.hasCustom ? '34%' : '50%',
        backgroundColor: '#fff',
        borderRadius: 10,
        transition: 'transform 0.3s ease',
        '&.monthly': {
            transform: 'translateX(0)',
        },
        '&.yearly': {
            transform: props.hasCustom ? 'translateX(94%)' : 'translateX(92%)'
        },
        '&.custom': {
            transform: 'translateX(186%)',
        },
    }),
    skeletonCard: {
        width: 300,
        margin: theme.spacing(0, 1),
        padding: theme.spacing(2),
        borderRadius: 12,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e0e0e0',
        minHeight: '400px',
        maxHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    header: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',

        '& .MuiButtonBase-root': {
            marginRight: '20px',
            marginTop: '20px'
        }
    },
    features: {
        maxHeight: '145px',
        overflow: 'auto'
    },
    seeMoreButton: {
        fontSize: '12px',
        color: '#5c4c6c',
        cursor: 'pointer',
        userSelect: 'none'
    },
    seeMore: {
        display: 'flex',
        justifyContent: 'flex-start',
        paddingLeft: '20px',
        paddingTop: '7px'
    },
    customFlag: {
        position: 'absolute',
        right: '12px',
        fontSize: '12px',
        fontWeight: '600',
        color: '#533030'
    },
    ribbon: {
        position: 'absolute',
        top: -42,
        right: -100,
        width: 200,
        backgroundColor: '#764815',
        color: '#ffffff',
        textAlign: 'center',
        transform: 'rotate(45deg)',
        transformOrigin: '0 0',
        boxShadow: '0px 0px 10px rgba(0,0,0,0.5)',
        pointerEvents: 'auto',
        fontWeight: 'bold',
    },
    selectPlanContainer: {
        width: '75%',
    },
    selectPlanText: {
        fontWeight: 600
    },
    trapezium: {
        content: '""',
        position: 'absolute',
        top: '-2px',
        right: '46px',
        width: '40%',
        height: '20px',
        backgroundColor: '#4659fd',
        clipPath: 'polygon(10% 0%, 90% 0%, 100% 100%, 0% 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '0.7rem',
        transform: 'scale(1.05)'
    },
}));